import React from 'react'
import { CopyField } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { Contract } from '../../../../common/validations'

interface CommonPaymentInformationProps {
  contract: Contract
}

export const CommonPaymentInformation: React.FC<
  CommonPaymentInformationProps
> = ({ contract }) => {
  const { t } = useTranslation(['payments'])
  return (
    <div className="flex flex-col gap-5 mt-16">
      {contract.propertyCompanyName && (
        <CopyField
          label={t('payments:paymentsBeneficiary')}
          value={contract.propertyCompanyName}
        />
      )}
      <CopyField
        label={t('payments:referenceNumber')}
        value={contract.referenceNumber}
      />
    </div>
  )
}
